/*eslint-disable no-process-env, no-undef */
import React, { Component, Fragment } from 'react'
// import ReactDOM from 'react-dom';
import PropTypes from 'prop-types'
import Wrapper from './wrapper'
import { unsubscribe } from '../../api'

export default class Unsubscribe extends Component {
	state = {
		unsubscribing: false,
		unsubscribed: false
	}

	constructor(props) {
		super(props)
		this.unsubscribe = this.unsubscribe.bind(this)
	}

	unsubscribe = async () => {
		let { accountId, unsubscribeToken } = this.props.match.params
		this.setState({unsubscribing: true})
		await unsubscribe(accountId, unsubscribeToken)
		// TODO: Handle different STATUS responses
		this.setState({unsubscribing: false, unsubscribed: true})
	}

	render() {
		if(this.state.unsubscribed) {
			return (
				<Wrapper>
					<h2>You have been unsubscribed!</h2>
				</Wrapper>
			)
		} else {
			return (
				<Wrapper>
					<Fragment>
						<h2>To permanently unsubscribe from AdMonitor, click the button below.</h2>
						<button className='unsubscribe' onClick={this.unsubscribe} disabled={this.state.unsubscribing}>
							Unsubscribe
						</button>
					</Fragment>
				</Wrapper>
			)
		}
		
	}
}

Unsubscribe.propTypes = {
	match: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/containers/Unsubscribe/index.js